import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IconSizes, BotIcon, GridIcon, SearchMdIcon } from '@newcore/icons';
import newcoreAppLogoHorizontal from '@/assets/newcore-app-logo-horizontal.svg';
import { ROUTES } from '@/common/auth-routes';
import { ApplicationSearchDialog } from '@/components/application-search/application-search-dialog';
import { useTenant } from '@/contexts/use-tenant';
import { TopNavItem } from './top-nav-item';
import { UserMenu } from './user-menu';

export const FloatingTopbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { tenant } = useTenant();
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault();
        setIsSearchOpen(true);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const isActive = (route: string) =>
    location.pathname === `/${tenant}${route}`;

  const goTo = (route: string) => navigate(`/${tenant}${route}`);

  return (
    <>
      <div className='absolute left-1/2 top-4.75 z-30 flex h-13 w-[calc(100%-3rem)] max-w-300 -translate-x-1/2 items-center gap-6 rounded-full bg-primary/80 py-2 pl-5.5 pr-3 shadow-[0_0_1px_0.5px_var(--color-border-primary),0_4px_4px_-3px_rgb(0_0_0/0.05)] backdrop-blur-xs'>
        <div className='flex shrink-0 items-center'>
          <button
            type='button'
            onClick={() => goTo(ROUTES.DASHBOARD)}
            aria-label='Applications home'
            className='-mx-2 flex h-9 items-center rounded-lg px-2 text-primary'
          >
            <img
              src={newcoreAppLogoHorizontal}
              alt='NewCore'
              className='h-5.25'
            />
          </button>
        </div>

        <nav
          aria-label='Portal'
          className='hidden h-full min-w-0 shrink items-center gap-2 overflow-hidden md:flex'
        >
          <TopNavItem
            label='Applications'
            icon={GridIcon}
            selected={isActive(ROUTES.DASHBOARD)}
            onClick={() => goTo(ROUTES.DASHBOARD)}
          />
          <TopNavItem
            label='Agents'
            icon={BotIcon}
            selected={location.pathname.startsWith(
              `/${tenant}${ROUTES.AGENTS}`
            )}
            onClick={() => goTo(ROUTES.AGENTS)}
          />
        </nav>

        <div className='flex flex-1 items-center justify-end gap-3'>
          <button
            type='button'
            onClick={() => setIsSearchOpen(true)}
            aria-label='Search  ⌘K'
            title='Search  ⌘K'
            className='flex size-9 shrink-0 items-center justify-center rounded-full border border-primary bg-primary text-secondary shadow-xs transition-colors hover:bg-tertiary'
          >
            <SearchMdIcon
              size={IconSizes.MD}
              strokeWidth={1.75}
              aria-hidden='true'
            />
          </button>

          <UserMenu />
        </div>
      </div>

      <ApplicationSearchDialog
        isOpen={isSearchOpen}
        onClose={() => setIsSearchOpen(false)}
      />
    </>
  );
};
